import { createSlice } from "@reduxjs/toolkit";
import { addBannersAPI } from "../../actions/banners/addBanners";

const initialState = {
  addBanners: {},
  loading: false,
  error: null,
};

const addBannersSlice = createSlice({
  name: "addBanners",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addBannersAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBannersAPI.fulfilled, (state, action) => {
        state.addBanners = action.payload.data;
        state.loading = false;
      })
      .addCase(addBannersAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { resetUserData } = addBannersSlice.actions;
export default addBannersSlice.reducer;
